import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalErrorHandlerService } from '../shared/services/global-error-handler.service';
import { HttpRequestService } from '../shared/services/http-request.service';
import { NotificationService } from '../shared/services/notification.service';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { ENDPOINTS } from '../shared/constants/url.constants';
import { formatUrl } from '../shared/utils/format-url-util';

@Injectable({
  providedIn: 'root',
})
export class ClaimAdjustmentService {
  constructor(
    private httpClient: HttpRequestService,
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService,
    private notificationService: NotificationService
  ) {}

  adjustClaims(payload: any, adjustType: any): Observable<any> {
    const url =
      adjustType === 'mco'
        ? ENDPOINTS.BILLING_CLAIMS_ADJ.ADJUST_MCO_CLAIM
        : ENDPOINTS.BILLING_CLAIMS_ADJ.ADJUST_SERVICE_CLAIM;
    return this.httpClient.post(url, payload, true).pipe(
      tap(),
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  adjustBulkClaims(payload: any): Observable<any> {
    return this.httpClient
      .post(ENDPOINTS.BILLING_CLAIMS_ADJ.ADJUST_BULK_CLAIM, payload, true)
      .pipe(
        tap(() => {
          this.notificationService.success(
            'Success',
            'File Uploaded Successfully.'
          );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      );
  }

  getAuthByMCO(
    programCode: string,
    participantId: any,
    mcoOrgId: any,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.BILLING_CLAIMS_ADJ.GET_AUTH_BY_MCO, {
      programCode,
      participantId,
      mcoOrgId,
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  downloadTemplate(programCode: string, type: string) {
    const headers = new HttpHeaders({
      Accept: 'multipart/form-data',
    });

    const endpoint =
      type === 'mco'
        ? ENDPOINTS.BILLING_CLAIMS_ADJ.DOWNLOAD_MCO_TEMPLATE
        : ENDPOINTS.BILLING_CLAIMS_ADJ.DOWNLOAD_SC_TEMPLATE;

    const url = formatUrl(endpoint, {
      programCode,
    });

    this.http
      .get(url, { headers: headers, responseType: 'blob', observe: 'response' })
      .subscribe(
        (response: any) => {
          const fileName =
            type === 'mco'
              ? 'ClaimsMCOAdjustment.xlsx'
              : 'ClaimsServiceAdjustment.xlsx';
          if (response.body) {
            const blob = new Blob([response.body], {
              type: response.body.type,
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          }
        },
        (error) => {
          console.error('unable to open the file', error);
        }
      );
  }

  getServiceCodesAndAuth(
    programCode: string,
    participantId: any,
    mcoOrgId?: any
  ): Observable<any> {
    const endpoint = mcoOrgId
      ? ENDPOINTS.BILLING_CLAIMS_ADJ.GET_AUTH
      : ENDPOINTS.BILLING_CLAIMS_ADJ.GET_SC;
    const url = formatUrl(endpoint, {
      programCode,
      participantId,
      mcoOrgId,
    });
    return this.http.get(url).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }
}
